<div class="modal-header container-md" id="modal-header">
    <div class="col-4"></div>
    <div class="col-4">
      <img id="modal-memorabid-logo" src="/assets/img/memorabid-logo-white.svg" alt="MEMORABID">
    </div>
    <div class="col-3"></div>
    <div class="col-1">
      <button id="closeButton" type="button" class="close" aria-label="Close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
</div>
<div class="modal-body mx-3">
    <div>
        <h3 class="text-uppercase">{{'IDS_NEWSLETTER' | translate}}</h3>
    </div>
    <div class="mt-3">
        <div class="error my-2" *ngIf="isEmailInvalid">
            <label>{{'IDS_EMAIL_NOT_VALID' | translate }}</label>
        </div>
        <form (ngSubmit)="subscribe(newsletterForm)" #newsletterForm="ngForm" *ngIf="!isEmailInvalid">
            <div class="d-flex mt-2">
                <label
                    [ngClass]="{'gold':isMemorabid, 'marketplace':!isMemorabid}"
                    class="fw-bold pb-2 me-2">
                    {{'IDS_EMAIL' | translate}}:
                </label>
                <label
                    [ngClass]="{'gold':isMemorabid, 'marketplace':!isMemorabid}"
                    class="pb-2">
                    {{ email }}
                </label>
            </div>
            <div class="d-flex justify-content-center mt-3">
                <button
                    type="submit"
                    [ngClass]="{'btn-gold':isMemorabid, 'btn-marketplace':!isMemorabid}"
                    class="btn-dialog text-uppercase fw-bold px-3">
                    {{'IDS_SUBSCRIBE' | translate}}
                </button>
            </div>
            <div class="d-flex justify-content-center my-3">
                <button class="admin-new text-uppercase fw-bold px-3" type="button" (click)="activeModal.close()">
                    {{'IDS_BTN_ABORT' | translate}}
                </button>
            </div>
        </form>
    </div>
</div>
